import { render, staticRenderFns } from "./tabAirApproveSettings.vue?vue&type=template&id=ba29613c&scoped=true&"
import script from "./tabAirApproveSettings.vue?vue&type=script&lang=js&"
export * from "./tabAirApproveSettings.vue?vue&type=script&lang=js&"
import style0 from "./tabAirApproveSettings.vue?vue&type=style&index=0&id=ba29613c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba29613c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba29613c')) {
      api.createRecord('ba29613c', component.options)
    } else {
      api.reload('ba29613c', component.options)
    }
    module.hot.accept("./tabAirApproveSettings.vue?vue&type=template&id=ba29613c&scoped=true&", function () {
      api.rerender('ba29613c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceAir/components/tabAirApproveSettings.vue"
export default component.exports